// Barrel export file for shared components (standalone)
// This replaces the old shared-components.module.ts

import { ReactiveFormsModule } from '@angular/forms';
import { SanitizeHtmlPipe } from '../pipes/sanitize-html.pipe';
import { SafeUrlPipe } from '../pipes/safe-url.pipe';
import { MaskEmailPipe } from '../pipes/mask-email.pipe';
import { BulkGridComponent } from './bulk-grid/bulk-grid.component';
import { FormElementCoreComponent } from './form-element-core/form-element-core.component';
import { ContentCardComponent } from './content-card/content-card.component';
import { WaitMessageComponent, WaitingIndicatorComponent } from '@nationwide/internet-servicing-angular-components';
import { ToUppercaseDirective } from '../directives/to-uppercase.directive';
import { AlphanumericDirective } from '../directives/alphanumeric.directive';
import { AlphanumericSpacesDirective } from '../directives/alphanumeric-spaces.directive';
import { NumbersOnlyDirective } from '../directives/numbersonly.directive';
import { CompanyNameDirective } from '../directives/company-name.directive';
import { ButtonClicktDirective } from '../directives/button-click.directive';

export const SHARED_COMPONENTS_IMPORTS = [
    ReactiveFormsModule,
    SanitizeHtmlPipe,
    SafeUrlPipe,
    MaskEmailPipe,
    BulkGridComponent,
    FormElementCoreComponent,
    ContentCardComponent,
    WaitMessageComponent,
    WaitingIndicatorComponent,
    ToUppercaseDirective,
    AlphanumericDirective,
    AlphanumericSpacesDirective,
    NumbersOnlyDirective,
    CompanyNameDirective,
    ButtonClicktDirective
];

export {
    SanitizeHtmlPipe,
    SafeUrlPipe,
    MaskEmailPipe,
    BulkGridComponent,
    FormElementCoreComponent,
    ContentCardComponent,
    WaitMessageComponent,
    WaitingIndicatorComponent,
    ToUppercaseDirective,
    AlphanumericDirective,
    AlphanumericSpacesDirective,
    NumbersOnlyDirective,
    CompanyNameDirective,
    ButtonClicktDirective
};